export const getIsTrialInLast15Days = (trialDaysLeft: number): boolean => {
	return 0 < trialDaysLeft && trialDaysLeft <= 15;
};
